import React, { useContext, useEffect, useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "../pages/LoginPage";
import ClientsRoutes from "../modules/clients/routes/ClientsRoutes";
import ExtractoHistoricoPage from "../modules/extractoHistorico/pages/ExtractoHistoricoPage";
import EgresosPage from "../modules/egresos/pages/EgresosPage";
import ComprobantePage from "../modules/egresos/pages/ComprobantePage";
import FacturaManualPage from "../modules/facturaManual/pages/FacturaManualPage";
import PlanillasPage from "../modules/planillas/pages/PlanillasPage";
import CatalogoEquiposPage from "../modules/catalogoEquipos/pages/CatalogoEquiposPage";
import CajaGeneralPage from "../modules/cajaGeneral/pages/CajaGeneralPage";
import CajaChicaPage from "../modules/cajaChica/pages/CajaChicaPage";
import CajaInstalacionPage from "../modules/cajaInstalacion/pages/CajaInstalacionPage";
import CajaProyectosPage from "../modules/cajaProyectos/pages/CajaProyectosPage";
import CajaViaticoPage from "../modules/cajaViatico/pages/CajaViaticoPage";
import CajaTecnicaPage from "../modules/cajaTecnica/pages/CajaTecnicaPage";
import CajaChicaElAltoPage from "../modules/cajaChicaElAlto/pages/CajaChicaElAltoPage";
import ProyectosListaPage from "../modules/proyecto/pages/ProyectosListaPage";
import ProyectoDetallePage from "../modules/proyecto/pages/ProyectoDetallePage";
import OrdenDeTrabajoPage from "../modules/ordenDeTrabajo/routes/OrdenDeTrabajoRoutes";
import VehiculosRoutes from "../modules/vehiculos/routes/VehiculosRoutes";
import CalendarioRoutes from "../modules/calendario/routes/CalendarioRoutes";
import RequerimientoRoutes from "../modules/requerimiento/routes/RequerimientoRoutes";
import TraspasoEquiposRoutes from "../modules/traspasoEquipos/routes/TraspasoEquiposRoutes";
import ReclamosRoutes from "../modules/reclamos/routes/ReclamosRoutes";
import ClienteServicioPage from "../modules/clienteServicio/pages/ClienteServicioPage";
import HistorialCliente from "../modules/historialCliente/routes/HistorialClienteRoutes";
import DocumentacionRoutes from "../modules/documentacion/routes/DocumentacionRoutes";
import WialonRoutes from "../modules/wialon/routes/WialonRoutes";
import LeasecontrolRoutes from "../modules/leasecontrol/routes/LeasecontrolRoutes";
import TrsRastreoRoutes from "../modules/trsrastreo/routes/TrsRastreoRoutes";
import IframePage from "../pages/IframePage";
import ChatbotRoutes from "../modules/chatbot/routes/ChatbotRoutes";
import ClientesPage from "../modules/clientes/routes/ClientesRoutes";
import FacturacionPage from "../modules/facturacion/pages/FacturacionPage";
import DetalleFacturaPage from "../modules/facturacion/pages/DetalleFacturaPage";
import FacturacionAdminPage from "../modules/facturacionAdmin/pages/FacturacionAdminPage";
import PagoMasivoPage from "../modules/pagoMasivo/pages/PagoMasivoPage";
import ReporteClienteRoutes from "../modules/reporteCliente/routes/ReporteClienteRoutes";
import ReporteFacturasRoutes from "../modules/reporteFacturas/routes/ReporteFacturasRoutes";
import ReporteImpuestosRoutes from "../modules/reporteImpuestos/routes/ReporteImpuestosRoutes";
import ReporteLibroVentasRoutes from "../modules/reporteLibroVentas/routes/ReporteLibroVentasRoutes";
import ReportePagosRoutes from "../modules/reportePagos/routes/ReportePagosRoutes";
import ReporteCierreRoutes from "../modules/reporteCierre/routes/ReporteCierreRoutes";
import CentroEquiposRoutes from "../modules/centroEquipos/routes/CentroEquiposRoutes";
import RegistroEquiposRoutes from "../modules/registroEquipos/routes/RegistroEquiposRoutes";
import ProgramacionEquipoRoutes from "../modules/programacionEquipo/routes/ProgramacionEquipoRoutes";
import FlespiRoutes from "../modules/flespi/routes/FlespiRoutes";
import DolarPage from "../modules/dolar/pages/DolarPage";
import TelusgyLeadsPage from "../modules/telusgyLeads/pages/TelusgyLeadsPage";
import TelusgyProductosPage from "../modules/telusgyProductos/pages/TelusgyProductosPage";
import TelusgyProyectosPage from "../modules/telusgyProyectos/pages/TelusgyProyectosPage";
import DocumentosRoutes from "../modules/documentos/routes/DocumentosRoutes";
import NotasPage from "../modules/notas/pages/NotasPage";
import SolicitudChequePage from "../modules/solicitudCheque/pages/SolicitudChequePage";
import OrdenesCompraPage from "../modules/ordenCompra/pages/OrdenesCompraPage";
import OrdenCompraDetallePage from "../modules/ordenCompra/pages/OrdenCompraDetallePage";
import DashboardFacturacionPage from "../modules/dashboardFacturacion/pages/DashboardFacturacionPage";
import MisSolicitudesPermisoPage from "../modules/permisos/pages/MisSolicitudesPermisoPage";
import SolicitudesPermisoAdminPage from "../modules/permisos/pages/SolicitudesPermisoAdminPage";
import CalendarioEquipoPage from "../modules/permisos/pages/CalendarioEquipoPage";
import AdministracionPersonalPage from "../modules/administracionPersonal/pages/AdministracionPersonalPage";
import AdministracionPersonalDetallePage from "../modules/administracionPersonal/pages/AdministracionPersonalDetallePage";
import AdministracionPersonalEmpleadoPage from "../modules/administracionPersonal/pages/AdministracionPersonalEmpleadoPage";
import InventarioInternoPage from "../modules/inventarioInterno/pages/InventarioInternoPage";
import VencimientoRoutes from "../modules/documentosVencimiento/routes/VencimientoRoutes";


import DashboardPage from "../pages/DashboardPage";
import MisClientesPage from "../pages/MisClientesPage";
import MetricasPage from "../pages/MetricasPage";
import ComparadorPlataformasPage from "../modules/comparadorPlataformas/pages/ComparadorPlataformasPage";
import PanelGlobalPage from "../modules/panelGlobal/pages/PanelGlobalPage";
import RevisionPlataformasPage from "../modules/revisionPlataformas/pages/RevisionPlataformasPage";
import MyAccount from "../pages/MyAccount";
import Settings from "../pages/Settings";
import AdminPage from "../pages/AdminPage";
import NoticiasPage from "../pages/NoticiasPage";
import NoticiaDetallePage from "../pages/NoticiaDetallePage";
import NotificacionesPage from "../pages/NotificacionesPage";
import ProtectedRoute from "./ProtectedRoute";
import { AuthProvider } from "../context/AuthContext";
import { SocketProvider } from "../context/SocketContext";

import IntroOverlay from "../components/IntroOverlay";
import MARCA from "../config/marca";
import { ThemeContext } from "../context/ThemeContext";

// Providers globales
import { ModemViewerProvider } from "../context/ModemViewerContext";
import { ReclamoModalProvider } from "../context/ReclamoModalContext";
import { VehiculoViewerProvider } from "../context/VehiculoViewerContext";

import GlobalMessageBridge from "../components/GlobalMessageBridge";
import InstallPwaButton from "../components/pwa/InstallPwaButton";

// TRS muestra su logo animado por capas (dura ~2.5 s); las demás marcas, una pantalla de carga corta.
const MINIMUM_INTRO_TIME_MS = MARCA.id ? 1500 : 2800;

const AppRoutes = () => {
  const { reducedMotion } = useContext(ThemeContext);
  const [showIntro, setShowIntro] = useState(true);
  const [isMinTimeElapsed, setIsMinTimeElapsed] = useState(false);

  useEffect(() => {
    const today = new Date().toISOString().slice(0, 10);
    const lastShown = localStorage.getItem("introLastShown");

    // Con "reducir movimiento" no hay intro: la pantalla de carga animada es
    // justo el tipo de movimiento que la preferencia pide evitar, y además
    // retrasa el primer render casi 3 s sin aportar información.
    if (reducedMotion) {
      setShowIntro(false);
      setIsMinTimeElapsed(true);
      return;
    }

    if (lastShown !== today) {
      setShowIntro(true);

      const minTimeTimer = setTimeout(() => {
        setIsMinTimeElapsed(true);
      }, MINIMUM_INTRO_TIME_MS);

      const saveDateTimer = setTimeout(() => {
        localStorage.setItem("introLastShown", today);
      }, MINIMUM_INTRO_TIME_MS + 100);

      return () => {
        clearTimeout(minTimeTimer);
        clearTimeout(saveDateTimer);
      };
    } else {
      setShowIntro(false);
      setIsMinTimeElapsed(true);
    }
  }, [reducedMotion]);

  useEffect(() => {
    if (isMinTimeElapsed && showIntro) {
      const fadeOutTimer = setTimeout(() => {
        setShowIntro(false);
      }, 500);
      return () => clearTimeout(fadeOutTimer);
    }
  }, [isMinTimeElapsed, showIntro]);

  return (
    <AuthProvider>
      <SocketProvider>
      {/* Ahora todos los viewers/modales globales viven aquí */}
      <ModemViewerProvider>
        <VehiculoViewerProvider>
          <ReclamoModalProvider>
            <GlobalMessageBridge />
            <InstallPwaButton />
            {showIntro && <IntroOverlay visible={showIntro} />}

            <Routes>
              <Route path="/login" element={<LoginPage />} />

              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <DashboardPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/mis-clientes"
                element={
                  <ProtectedRoute>
                    <MisClientesPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/metricas"
                element={
                  <ProtectedRoute>
                    <MetricasPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/comparador-plataformas"
                element={
                  <ProtectedRoute>
                    <ComparadorPlataformasPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/panel-global"
                element={
                  <ProtectedRoute>
                    <PanelGlobalPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/revision-plataformas"
                element={
                  <ProtectedRoute>
                    <RevisionPlataformasPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/users"
                element={<Navigate to="/admin/usuarios" replace />}
              />
              <Route
                path="/admin/*"
                element={
                  <ProtectedRoute>
                    <AdminPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/noticias"
                element={
                  <ProtectedRoute>
                    <NoticiasPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/noticias/:id"
                element={
                  <ProtectedRoute>
                    <NoticiaDetallePage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/notificaciones"
                element={
                  <ProtectedRoute>
                    <NotificacionesPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/mi-cuenta"
                element={
                  <ProtectedRoute>
                    <MyAccount />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/configuracion"
                element={
                  <ProtectedRoute>
                    <Settings />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/clients/*"
                element={
                  <ProtectedRoute>
                    <ClientsRoutes />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/caja-general"
                element={
                  <ProtectedRoute>
                    <CajaGeneralPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/caja-chica"
                element={
                  <ProtectedRoute>
                    <CajaChicaPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/caja-instalacion"
                element={
                  <ProtectedRoute>
                    <CajaInstalacionPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/caja-proyectos"
                element={
                  <ProtectedRoute>
                    <CajaProyectosPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/caja-viatico"
                element={
                  <ProtectedRoute>
                    <CajaViaticoPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/caja-tecnica"
                element={
                  <ProtectedRoute>
                    <CajaTecnicaPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/caja-chica-el-alto"
                element={
                  <ProtectedRoute>
                    <CajaChicaElAltoPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/proyectos"
                element={
                  <ProtectedRoute>
                    <ProyectosListaPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/proyectos/:id"
                element={
                  <ProtectedRoute>
                    <ProyectoDetallePage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/extracto-historico"
                element={
                  <ProtectedRoute>
                    <ExtractoHistoricoPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/egresos"
                element={
                  <ProtectedRoute roles={["admin", "gerente", "conta"]}>
                    <EgresosPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/egresos/comprobante/:id"
                element={
                  <ProtectedRoute roles={["admin", "gerente", "conta"]}>
                    <ComprobantePage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/factura-manual"
                element={
                  <ProtectedRoute roles={["admin", "gerente", "conta"]}>
                    <FacturaManualPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/planillas"
                element={
                  <ProtectedRoute roles={["admin", "gerente", "conta"]}>
                    <PlanillasPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/modelos-equipos"
                element={
                  <ProtectedRoute roles={["admin", "gerente"]}>
                    <CatalogoEquiposPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/permisos/mis-solicitudes"
                element={
                  <ProtectedRoute>
                    <MisSolicitudesPermisoPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/permisos/solicitudes"
                element={
                  <ProtectedRoute>
                    <SolicitudesPermisoAdminPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/permisos/calendario"
                element={
                  <ProtectedRoute>
                    <CalendarioEquipoPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/administracion-personal"
                element={
                  <ProtectedRoute>
                    <AdministracionPersonalPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/administracion-personal/detalle"
                element={
                  <ProtectedRoute>
                    <AdministracionPersonalDetallePage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/administracion-personal/empleado/:id"
                element={
                  <ProtectedRoute>
                    <AdministracionPersonalEmpleadoPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/inventario-interno"
                element={
                  <ProtectedRoute>
                    <InventarioInternoPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/orden-de-trabajo/*"
                element={
                  <ProtectedRoute>
                    <OrdenDeTrabajoPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/requerimiento/*"
                element={
                  <ProtectedRoute>
                    <RequerimientoRoutes />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/vehiculos/*"
                element={
                  <ProtectedRoute>
                    <VehiculosRoutes />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/calendario"
                element={
                  <ProtectedRoute>
                    <CalendarioRoutes />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/traspaso-equipos/*"
                element={
                  <ProtectedRoute>
                    <TraspasoEquiposRoutes />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/reclamos/*"
                element={
                  <ProtectedRoute>
                    <ReclamosRoutes />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/cliente-servicio"
                element={
                  <ProtectedRoute>
                    <ClienteServicioPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/historial-cliente/*"
                element={
                  <ProtectedRoute>
                    <HistorialCliente />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/documentacion/*"
                element={
                  <ProtectedRoute>
                    <DocumentacionRoutes />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/wialon/*"
                element={
                  <ProtectedRoute>
                    <WialonRoutes />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/leasecontrol/*"
                element={
                  <ProtectedRoute>
                    <LeasecontrolRoutes />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/trsrastreo/*"
                element={
                  <ProtectedRoute>
                    <TrsRastreoRoutes />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/embed/:key"
                element={
                  <ProtectedRoute>
                    <IframePage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/chatbot/*"
                element={
                  <ProtectedRoute>
                    <ChatbotRoutes />
                  </ProtectedRoute>
                } />
              <Route
                path="/clientes/*"
                element={
                  <ProtectedRoute>
                    <ClientesPage />
                  </ProtectedRoute>
                }
              />
              <Route path="/facturacion" element={
                <ProtectedRoute>
                  <FacturacionPage />
                </ProtectedRoute>
              } />
              <Route path="/facturacion/facturas/:cod" element={
                <ProtectedRoute>
                  <DetalleFacturaPage />
                </ProtectedRoute>
              } />
              <Route path="/facturacion-admin" element={
                <ProtectedRoute>
                  <FacturacionAdminPage />
                </ProtectedRoute>
              } />
              <Route path="/pago-masivo" element={
                <ProtectedRoute>
                  <PagoMasivoPage />
                </ProtectedRoute>
              } />
              <Route path="/reporte-cliente/*" element={
                <ProtectedRoute>
                  <ReporteClienteRoutes />
                </ProtectedRoute>
              } />
              <Route path="/reporte-facturas/*" element={
                <ProtectedRoute>
                  <ReporteFacturasRoutes />
                </ProtectedRoute>
              } />
              <Route path="/reporte-impuestos/*" element={
                <ProtectedRoute>
                  <ReporteImpuestosRoutes />
                </ProtectedRoute>
              } />
              <Route path="/reporte-libro-ventas/*" element={
                <ProtectedRoute>
                  <ReporteLibroVentasRoutes />
                </ProtectedRoute>
              } />
              <Route path="/reporte-pagos/*" element={
                <ProtectedRoute>
                  <ReportePagosRoutes />
                </ProtectedRoute>
              } />
              <Route path="/reporte-cierre/*" element={
                <ProtectedRoute>
                  <ReporteCierreRoutes />
                </ProtectedRoute>
              } />
              <Route path="/centro-equipos/*" element={
                <ProtectedRoute>
                  <CentroEquiposRoutes />
                </ProtectedRoute>
              } />
              <Route path="/registro-equipos/*" element={
                <ProtectedRoute>
                  <RegistroEquiposRoutes />
                </ProtectedRoute>
              } />
              <Route path="/programacion-equipo/*" element={
                <ProtectedRoute>
                  <ProgramacionEquipoRoutes />
                </ProtectedRoute>
              } />
              <Route path="/flespi/*" element={
                <ProtectedRoute>
                  <FlespiRoutes />
                </ProtectedRoute>
              } />
              <Route path="/tipo-cambio" element={
                <ProtectedRoute>
                  <DolarPage />
                </ProtectedRoute>
              } />
              <Route path="/dashboard-facturacion" element={
                <ProtectedRoute>
                  <DashboardFacturacionPage />
                </ProtectedRoute>
              } />
              <Route path="/ordenes-compra" element={
                <ProtectedRoute>
                  <OrdenesCompraPage />
                </ProtectedRoute>
              } />
              <Route path="/ordenes-compra/:id" element={
                <ProtectedRoute>
                  <OrdenCompraDetallePage />
                </ProtectedRoute>
              } />
              <Route path="/solicitud-cheque" element={
                <ProtectedRoute>
                  <SolicitudChequePage />
                </ProtectedRoute>
              } />
              <Route path="/notas" element={
                <ProtectedRoute>
                  <NotasPage />
                </ProtectedRoute>
              } />
              <Route path="/documentos/*" element={
                <ProtectedRoute>
                  <DocumentosRoutes />
                </ProtectedRoute>
              } />
              <Route path="/vencimientos/*" element={
                <ProtectedRoute>
                  <VencimientoRoutes />
                </ProtectedRoute>
              } />
              <Route path="/telusgy/leads" element={
                <ProtectedRoute>
                  <TelusgyLeadsPage />
                </ProtectedRoute>
              } />
              <Route path="/telusgy/productos" element={
                <ProtectedRoute>
                  <TelusgyProductosPage />
                </ProtectedRoute>
              } />
              <Route path="/telusgy/proyectos" element={
                <ProtectedRoute>
                  <TelusgyProyectosPage />
                </ProtectedRoute>
              } />

              {/* fallback */}
              <Route path="*" element={<Navigate to="/login" replace />} />
            </Routes>
          </ReclamoModalProvider>
        </VehiculoViewerProvider>
      </ModemViewerProvider>
      </SocketProvider>
    </AuthProvider>
  );
};

export default AppRoutes;
